export const convertToHtmlList = (descriptions: string[]) => {
  if (descriptions && descriptions.length > 0) {
    return `<ol>${descriptions
      .map(
        (line: string) =>
          `<li data-list="bullet"><span class="ql-ui" contenteditable="false"></span>${line}</li>`
      )
      .join("")}</ol>`;
  }
  return ``;
};
